import { IResourceComponentsProps } from "@pankod/refine-core";
import { DATAPROVIDER_CREATE } from "scripts/site";
import { RequestForm } from "./requestForm";

export const CreateResourcingRequest: React.FC<IResourceComponentsProps> = () => {
    return (
        <RequestForm dataProvider={DATAPROVIDER_CREATE} />
    );
};